var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenmo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "venmo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.2461 10.2832C38.3203 12.0508 38.7988 13.8672 38.7988 16.1719C38.7988 23.5059 32.5391 33.0371 27.4512 39.7266H15.8496L11.2012 11.8945L21.3672 10.9277L23.8379 30.7324C26.1328 26.9824 28.9746 21.0938 28.9746 17.0898C28.9746 14.8926 28.5938 13.3984 28.0078 12.168L37.2461 10.2832Z",
    fill: "#3396CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenmo);
export default __webpack_public_path__ + "static/media/venmo.8bdfcc33ac0f69520ad8b61a50ad2bfa.svg";
export { ForwardRef as ReactComponent };